import { useMemo } from 'react';

import { MenuConfigItem } from '@/config/menuConfig';

export const useAllowedToView = (menuConfig: MenuConfigItem[] | null, currentPathname: string) => {
	// Returns a boolean indicating whether the user is allowed to view the current page based on the menuConfig and currentPathname.
	// menuConfig contains all the pages that the user can access based on their role and feature flags.
	const isAllowedToView = useMemo(() => {
		// if no menuConfig is provided or route is home page, then allow access by default
		if (!menuConfig || currentPathname === '/' || currentPathname === '') return true;
		// generate an array of all the menu links from the menuConfig object
		const menuLinks = Object.values(menuConfig)
			.flat()
			.map((item) => item.link);
		// get the root url from the current path and check if it matches any of the menu links
		const currentPathSplit = currentPathname.split('/');
		// urls should begin with a '/', so the first element of the split array will be empty. The second element will be the root url, which is what we want to check against the menu links
		const currentPathBase = currentPathSplit.length > 1 ? currentPathSplit[1] : '';
		const isAvailablePage = menuLinks.some((link) => link.includes(currentPathBase));
		return isAvailablePage;
	}, [menuConfig, currentPathname]);

	return isAllowedToView;
};
